import { render, staticRenderFns } from "./ChapterTitle.vue?vue&type=template&id=98519176&scoped=true"
import script from "./ChapterTitle.vue?vue&type=script&lang=js"
export * from "./ChapterTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98519176",
  null
  
)

export default component.exports